import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yammer': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M421.8 152.2c-48.2 26.4-118.6 58.2-130.2 50s91.4-80.4 106.7-88.8c0.9-0.5 1.8-1 2.6-1.4 1.8-0.5 4.7-0.9 6.5-0.9 12.7 0 23.1 10.3 23.1 23.1 0 6.1-3.9 14.2-8.7 18.1zM421.8 369.3c4.8 3.8 8.6 11.9 8.6 18 0 12.7-10.3 23.1-23.1 23.1-1.8 0-4.7-0.4-6.4-0.9-0.8-0.4-1.7-0.9-2.6-1.4-15.3-8.4-118.3-80.6-106.7-88.7 11.6-8.1 82 23.6 130.2 50zM464.2 237c10.1 2.1 18.3 12.2 18.3 22.5 0 10.8-8.6 21-19.3 22.7-54.9 0-131.9-6-138.2-18.8-6.3-12.8 118.8-26.5 136.2-26.5 1 0 2 0.1 3 0.1zM31 96.6c-0.7-2.1-1.3-5.6-1.3-7.8 0-13.7 11.1-24.9 24.9-24.9 8.7 0 18.8 6.4 22.5 14.3l81 205.1h1.2l77-203.5c3.2-8.3 13-15 21.9-15 13 0 23.5 10.5 23.5 23.5 0 1.9-0.4 4.9-1 6.7l-109.6 273.4c-18.5 47.2-37.1 79.6-93.3 79.6-0.2 0-0.4 0-0.5 0-6.5 0-16.9-0.9-23.3-2-8.5-2.4-15.4-11.6-15.4-20.5 0-11.8 9.5-21.3 21.3-21.3 0.3 0 0.7 0 1 0 0.7 0.1 10.9 0.7 13.9 0.7 30.5 0 43.7-18.9 58.1-59.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yammer.js
// module id = 1107
// module chunks = 0